// services/isp.js
import axiosInstance from './axiosInstance';

const ISP_API_URL = '/isp';

const ispService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${ISP_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter ISP:', error);
      return [];
    }
  },

  async set(ispData) {
    try {
      const response = await axiosInstance.post(`${ISP_API_URL}/set.php`, ispData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar ISP:', error);
      throw error;
    }
  },

  async unset(idempresa, idisp) {
    try {
      const response = await axiosInstance.get(`${ISP_API_URL}/unset.php?idempresa=${idempresa}&idisp=${idisp}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover ISP:', error);
      throw error;
    }
  }
};

export default ispService;
